import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ActivitySalesforceComponent } from './activity/activity-salesforce.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigurationService } from './configuration.service';
import { CreateSalesforceComponent } from './create/create-salesforce.component';
import { CreateV2Component } from './create-v2/create-v2.component';
import { HomeSalesforceComponent } from './home/home-salesforce.component';
import { LoggerService } from './logger.service';
import { MatCommonModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecentActivitiesComponent } from './recentactivities/recentactivities.component';
import { RouterModule } from '@angular/router';
import { SalesforceComponent } from './salesforce.component';
import { SearchInformationSalesforceComponent } from './search-information-salesforce/search-information-salesforce.component';
import { StorageService } from './storage.service';
import { UILibraryModule } from '@amc-technology/ui-library';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SalesforceComponent, HomeSalesforceComponent, ActivitySalesforceComponent, CreateSalesforceComponent, SearchInformationSalesforceComponent, RecentActivitiesComponent, CreateV2Component],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([{ path: '', component: HomeSalesforceComponent, pathMatch: 'full' }]),
    CommonModule,
    NgbModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatInputModule,
    MatTabsModule,
    MatSelectModule,
    MatExpansionModule,
    MatCommonModule,
    UILibraryModule
  ],
  providers: [
    LoggerService,
    StorageService,
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigurationService, loggerService: LoggerService) => async () => {
        await configService.loadConfigurationData();
        await loggerService.initialize();
      },
      deps: [ConfigurationService, LoggerService],
      multi: true
    },
  ],
  bootstrap: [SalesforceComponent]
})
export class AppModule { }
